import { connect } from 'react-redux';
import { getCurrentUsage, getCurrentCycle, getCurrentSprintPlan } from 'reducers';
import { fetch as fetchCycles } from 'billing/cycles/actions';
import { findCurrent as findCurrentUsage } from 'subscriptions/usage/sprint/actions';
import DataRemaining from './DataRemaining';

const mapStateToProps = (state, { subId }) => ({
  usage: getCurrentUsage(state, subId),
  currentCycle: getCurrentCycle(state),
  currentPlan: getCurrentSprintPlan(state, subId),
});

const mapDispatchToProps = {
  fetchCycles,
  findCurrentUsage,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DataRemaining);
